import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzWeekDay } from './sz-week-strip.types';

@Component({
  selector: 'sz-week-strip',
  templateUrl: './sz-week-strip.component.html',
  styleUrls: ['./sz-week-strip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzWeekStripComponent {
  readonly days: InputSignal<ReadonlyArray<SzWeekDay>> = input.required<ReadonlyArray<SzWeekDay>>();
}
